"use client";

import { useAuth } from "../context/AuthContext";

export default function Menu() {

  // const { role, logout, nickname } = useAuth();
  const { role, logout, nickname, approved } = useAuth();

  function labelUsuario() {
    if (role === "USER") return nickname || "Comprador";
    if (role === "OPERATOR") return "Operador";
    if (role === "ADMIN") return "Admin";
    return null;
  }

  const usuario = labelUsuario();

  return (
    <nav
      style={{
        padding: 12,
        background: "#111",
        color: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >

      {/* MENU ESQUERDA */}
      <div>

        <a href="/" style={{ color:"#fff", marginRight:15 }}>
          Home
        </a>
        <a href="/auction" style={{ color:"#fff", marginRight:15 }}>
          Agenda
        </a>
        <a href="/auction/1" style={{ color:"#fff", marginRight:15 }}>
          Catálogo Teste
        </a>
        <a href="/cadastro" style={{color:"#fff", marginRight:15}}>
          Cadastrar 
        </a>
       
       
        {role === "USER" && !approved && (
        <a href="/me/documentos" style={{ color:"#fff", marginRight:15 }}>
          Enviar Documentos
        </a>
        )}
        {role === "USER" && approved && (
        <>
        <a href="/minhas-arrematacoes" style={{ color:"#fff", marginRight:15 }}>
        Minhas Arrematações
        </a>
        </>
        )}

      </div>

      {/* ADMIN / OPERATOR */}
      <div>

        {(role === "ADMIN" || role === "OPERATOR") && (
          <a href="/operator" style={{ color:"#fff", marginRight:15 }}>
            Operador
          </a>
        )}

        {role === "ADMIN" && (
          <>
            <a href="/admin/auctions" style={{color:"#fff", marginRight:15}}>
              Leilões
            </a>
            
            <a href="/finance" style={{ color:"#fff", marginRight:15 }}>
              Financeiro
            </a>

            <a href="/admin/dashboard" style={{ color:"#fff", marginRight:15 }}>
              Dashboard
            </a>
            <a href="/admin/users" style={{color:"#fff",marginRight:15}}>
              Usuários
            </a>

            <a href="/admin/live" style={{color:"#fff",marginRight:15}}>
            Monitor
            </a>

            <a href="/admin" style={{ color:"#fff", marginRight:15 }}>
              Admin
            </a>
          </>
        )}

      </div>

      {/* LOGIN */}
      <div>

        {usuario ? (
          <>
            Logado como: <strong>{usuario}</strong>

            <button
              onClick={logout}
              style={{
                marginLeft:15,
                padding:"4px 8px",
                cursor:"pointer"
              }}
            >
              Logout
            </button>
          </>
        ) : (
          <a href="/login" style={{ color:"#fff" }}>
            Login
          </a>
        )}

      </div>

    </nav>
  );
}